<template>
  <div class="d-flex align-center" style="width: 100%">
    <v-btn variant="text" color="primary" large>
      <div class="d-flex align-center">
        <v-icon start large color="primary">mdi-calendar</v-icon>
        <div class="pl-2 date-button">{{ formattedDate }}</div>
      </div>
    </v-btn>

    <div>
      <v-btn @click="subtract" variant="text" color="primary">
        <v-icon start>mdi-chevron-left</v-icon>
        {{ $t('common.previousMonth') }}
      </v-btn>
    </div>
    <div>
      <v-btn @click="add" variant="text" color="primary">
        {{ $t('common.nextMonth') }}
        <v-icon end>mdi-chevron-right</v-icon>
      </v-btn>
    </div>
  </div>
</template>
<script lang="ts">
import { defineComponent } from "vue";
import dayjs, { Dayjs } from "dayjs";
import "dayjs/locale/en";

export default defineComponent({
  emits: ["update:modelValue"],

  props: {
    modelValue: {
      type: String,
      required: false,
    },
    month: {
      type: String,
      required: false,
    },
  },

  mounted() {
    dayjs.locale("en");
  },

  watch: {},

  data() {
    return {
      formatString: "MMMM YYYY",
      open: false,
    };
  },

  computed: {
    formattedDate(): string {
      if (this.modelValue) {
        return dayjs(this.modelValue).format(this.formatString);
      }
      return dayjs().format(this.formatString);
    },
  },

  methods: {
    add() {
      if (this.modelValue) {
        const newValue = dayjs(this.modelValue).add(1, "month").format("YYYY-MM");
        this.$emit("update:modelValue", newValue);
        return;
      }
    },
    subtract() {
      if (this.modelValue) {
        const newValue = dayjs(this.modelValue).subtract(1, "month").format("YYYY-MM");
        this.$emit("update:modelValue", newValue);
        return;
      }
    },
  },
});
</script>

<style scoped>
.date-button {
  font-size: 1.4rem;
}
</style>
